import { delay } from "../../utils";
import "./style.css";

function CustomButton({ isPrimary = true, children, onClick, className = "", id = "", style = {}, disabled = false, size = "medium" }) {
    return (
        <button
            id={id}
            style={style}
            className={(isPrimary ? "primary-button " : "secondary-button ") + className + " " + ("cb-size-" + size) + (" cb-disabled-" + disabled)}
            onClick={(e) => {
                e.preventDefault();
                delay(() => {
                    onClick(e);
                }, 200)
            }}
            disabled={disabled}
        >
            {children}
        </button>
    );
}

export default CustomButton;